import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-survey-image",
  templateUrl: "./survey-image.component.html",
  styleUrls: ["./survey-image.component.scss"],
  standalone: false
})
export class SurveyImageComponent implements OnInit, OnDestroy {
  @Input() questionDetails: any;
  @Output() answerSelectedEvent = new EventEmitter<any>();

  imageSources: string[] = [];
  preloadHiddenImageSources: string[] = [];
  answerIds: string[] = [];
  selectedImageIndex = -1;
  answerText: string;
  sleepinessSelectedImageFile: string;
  selectYourSleepinessStringId: string;

  ngOnInit(): void {
    for (const answer of this.questionDetails.PossibleAnswers) {
      this.imageSources.push(answer.Images.Unselected);
      this.preloadHiddenImageSources.push(answer.Images.Selected);
      this.answerIds.push(answer.AnswerId);
    }

    if (this.questionDetails.hasOwnProperty("SelectedAnswer")) {
      this.highlightSelectedImage(this.questionDetails.SelectedAnswer.Index);
    }

    this.sleepinessSelectedImageFile = this.questionDetails.hasOwnProperty("SelectedAnswer") ? this.imageSources[this.questionDetails.SelectedAnswer.Index] : "sleepy_default.svg";
    this.selectYourSleepinessStringId = this.questionDetails.hasOwnProperty("SelectYourImageText") ? this.questionDetails.SelectYourImageText : "select-your-sleepiness";
  }

  ngOnDestroy(): void {
  }

  imageSelected(answer: any, index: number): void {
    answer.Index = index;
    this.answerSelectedEvent.emit(answer);
    this.highlightSelectedImage(index);
    this.answerText = answer.AnswerText ? answer.AnswerText : null;
  }

  highlightSelectedImage(index: number): void {
    if (this.selectedImageIndex >= 0) {
      // reset original image only if one is selected already
      this.imageSources[this.selectedImageIndex] = this.questionDetails.PossibleAnswers[this.selectedImageIndex].Images.Unselected;
    }
    this.imageSources[index] = this.questionDetails.PossibleAnswers[index].Images.Selected;
    this.sleepinessSelectedImageFile =  this.imageSources[index];
    this.selectedImageIndex = index;
    this.answerText = this.questionDetails.PossibleAnswers[this.selectedImageIndex].AnswerText;
  }
}
